module.exports = __webpack_public_path__ + "img/enston-address.65ee93b5.svg";